var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#ffffff",
      display: "block",
      zIndex: 1,
      position: "relative",
      transform: "rotate(180deg)"
    },
    width: 1859,
    height: 950,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 450 1859 950",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.11901419181988993",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90cb7c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8ba7",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 855.406 Q 185.9 723.951 371.8 692.287 T 743.6 701.254 T 1115.4 512.253 T 1487.2 454.601 T 1859 361.109 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 854.8495729913462Q 185.9 729.2504918085272  371.8 698.4452818342734T 743.6 710.3157707518208T 1115.4 516.9793373845439T 1487.2 450.94401351385125T 1859 367.24281235954896L 1859 0 Z;M0 0L 0 860.6840165746378Q 185.9 673.6315181491154  371.8 633.8215294530964T 743.6 615.2187200719693T 1115.4 467.3773160705783T 1487.2 489.32751477913206T 1859 302.87244299722977L 1859 0 Z;M0 0L 0 735.2076515730786Q 185.9 714.42685483161  371.8 662.5470436856216T 743.6 671.5111091047376T 1115.4 500.30975700968304T 1487.2 533.6593731121966T 1859 412.4568953461212L 1859 0 Z;M0 0L 0 854.8495729913462Q 185.9 729.2504918085272  371.8 698.4452818342734T 743.6 710.3157707518208T 1115.4 516.9793373845439T 1487.2 450.94401351385125T 1859 367.24281235954896L 1859 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 810.962 Q 185.9 769.459 371.8 731.39 T 743.6 631.458 T 1115.4 602.242 T 1487.2 449.753 T 1859 372.323 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-1.6666666666666667s",
    values: "M0 0L 0 877.3676961063404Q 185.9 680.9461199950852  371.8 644.105208901465T 743.6 619.9672514646197T 1115.4 545.6741914642441T 1487.2 407.29022794694606T 1859 444.99730627378534L 1859 0 Z;M0 0L 0 765.9091864690322Q 185.9 829.5102366759577  371.8 790.6089385923688T 743.6 639.2542534853815T 1115.4 640.62112268622T 1487.2 478.56236971851797T 1859 323.01753280787045L 1859 0 Z;M0 0L 0 799.0455820854173Q 185.9 703.1662353708286  371.8 679.1717586934087T 743.6 562.8920358799184T 1115.4 600.0009318748433T 1487.2 490.99919314783574T 1859 397.5431905800425L 1859 0 Z;M0 0L 0 877.3676961063404Q 185.9 680.9461199950852  371.8 644.105208901465T 743.6 619.9672514646197T 1115.4 545.6741914642441T 1487.2 407.29022794694606T 1859 444.99730627378534L 1859 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 829.757 Q 185.9 716.703 371.8 685.306 T 743.6 703.844 T 1115.4 520.707 T 1487.2 527.708 T 1859 424.088 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-3.3333333333333335s",
    values: "M0 0L 0 783.3628011745282Q 185.9 707.0895424499516  371.8 667.6647880736787T 743.6 613.5907957214057T 1115.4 544.0506422930714T 1487.2 422.25155522725777T 1859 363.2819753447084L 1859 0 Z;M0 0L 0 835.0889196552189Q 185.9 710.8127187221953  371.8 680.0859142459994T 743.6 710.6530479350939T 1115.4 512.4710225256098T 1487.2 534.1595973730978T 1859 422.46199611177116L 1859 0 Z;M0 0L 0 779.5443541994869Q 185.9 772.1661049770611  371.8 734.4583624198646T 743.6 639.7205037017179T 1115.4 598.2610238135853T 1487.2 466.95580222117053T 1859 439.3959203309555L 1859 0 Z;M0 0L 0 783.3628011745282Q 185.9 707.0895424499516  371.8 667.6647880736787T 743.6 613.5907957214057T 1115.4 544.0506422930714T 1487.2 422.25155522725777T 1859 363.2819753447084L 1859 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 800.795 Q 185.9 739.38 371.8 713.919 T 743.6 642.467 T 1115.4 565.885 T 1487.2 461.878 T 1859 303.311 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-5s",
    values: "M0 0L 0 738.9964894947158Q 185.9 718.3289399416481  371.8 697.8581151850865T 743.6 594.3737710958676T 1115.4 518.7759264620163T 1487.2 430.9504527382114T 1859 386.22341927386117L 1859 0 Z;M0 0L 0 782.2341207640093Q 185.9 675.3450758595566  371.8 641.5961807989412T 743.6 599.7212584689566T 1115.4 553.6974629459519T 1487.2 512.0050133263276T 1859 343.416293694744L 1859 0 Z;M0 0L 0 813.4284706064865Q 185.9 782.9671667175484  371.8 763.1467437224624T 743.6 671.5630991660003T 1115.4 574.1812404547652T 1487.2 427.7583671638116T 1859 276.01214528246106L 1859 0 Z;M0 0L 0 738.9964894947158Q 185.9 718.3289399416481  371.8 697.8581151850865T 743.6 594.3737710958676T 1115.4 518.7759264620163T 1487.2 430.9504527382114T 1859 386.22341927386117L 1859 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 735.717 Q 185.9 710.047 371.8 672.708 T 743.6 641.204 T 1115.4 537.94 T 1487.2 424.844 T 1859 427.265 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-6.666666666666667s",
    values: "M0 0L 0 775.7725617418129Q 185.9 824.5614769182824  371.8 780.37921476551T 743.6 645.6277156662824T 1115.4 601.6595938375793T 1487.2 461.91499475425763T 1859 283.8568716669446L 1859 0 Z;M0 0L 0 768.0746892600051Q 185.9 771.3993798509393  371.8 739.4803805077372T 743.6 653.3597711131661T 1115.4 511.0744822081605T 1487.2 435.8296864116161T 1859 313.45533609713726L 1859 0 Z;M0 0L 0 731.5468038155234Q 185.9 698.1257594799072  371.8 661.4990716909574T 743.6 640.743698765045T 1115.4 531.3063964049272T 1487.2 420.98455296246345T 1859 442.19364126289025L 1859 0 Z;M0 0L 0 775.7725617418129Q 185.9 824.5614769182824  371.8 780.37921476551T 743.6 645.6277156662824T 1115.4 601.6595938375793T 1487.2 461.91499475425763T 1859 283.8568716669446L 1859 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 811.489 Q 185.9 740.158 371.8 700.721 T 743.6 644.836 T 1115.4 558.511 T 1487.2 395.972 T 1859 312.218 L 1859 0 Z",
    fill: "url(#lg-0.11901419181988993)",
    opacity: 0.41000000000000003
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-8.333333333333334s",
    values: "M0 0L 0 856.9454076100067Q 185.9 774.3940625827335  371.8 739.1905020613732T 743.6 618.6965962078416T 1115.4 604.4920392776385T 1487.2 368.5906521398073T 1859 284.95665986086453L 1859 0 Z;M0 0L 0 744.5019154725496Q 185.9 782.4856976127115  371.8 747.3972422819385T 743.6 602.4821556022229T 1115.4 462.21247827558426T 1487.2 508.1021992956218T 1859 377.49340126169915L 1859 0 Z;M0 0L 0 744.7655959619271Q 185.9 689.9063075279761  371.8 644.2537512015766T 743.6 683.203376445653T 1115.4 491.0197959574686T 1487.2 436.1628969279069T 1859 352.23358972455935L 1859 0 Z;M0 0L 0 856.9454076100067Q 185.9 774.3940625827335  371.8 739.1905020613732T 743.6 618.6965962078416T 1115.4 604.4920392776385T 1487.2 368.5906521398073T 1859 284.95665986086453L 1859 0 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.bbd4cddef2d4df63a1e16a962f0a5a0d.svg";
export { ForwardRef as ReactComponent };